<!--
  微信内打开时的遮罩提示，引导用户点击右上角用浏览器打开。
  点击任意位置关闭遮罩。
-->
<script lang="ts">
  import { _ as t } from "svelte-i18n";

  interface Props {
    show: boolean;
    onClose: () => void;
  }

  let { show, onClose }: Props = $props();
</script>

{#if show}
  <!-- svelte-ignore a11y_click_events_have_key_events a11y_no_static_element_interactions -->
  <div
    class="fixed inset-0 z-[9999] flex flex-col bg-black/70 px-[16px] pt-[48px] text-white"
    onclick={onClose}
  >
    <!-- 右上角箭头指向"更多"按钮 -->
    <div class="absolute right-[32px] top-[12px]">
      <svg
        width="86"
        height="60"
        viewBox="0 0 86 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <!-- 弯曲箭头指向右上角 -->
        <path
          d="M10 55 Q 40 50, 50 30 Q 60 10, 75 8"
          stroke="white"
          stroke-width="3"
          fill="none"
          stroke-linecap="round"
        />
        <!-- 箭头头部 -->
        <path
          d="M68 3 L76 8 L70 14"
          stroke="white"
          stroke-width="3"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>

    <!-- 提示文案 -->
    <div class="mt-[24px] text-[18px] leading-[28px] pl-[50px]">
      <div class="flex items-center gap-[8px]">
        <span>{$t("wechat_tip_1")}</span>
        <!-- 三个点图标，模拟微信右上角"更多"按钮 -->
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="5" cy="12" r="2" fill="white" />
          <circle cx="12" cy="12" r="2" fill="white" />
          <circle cx="19" cy="12" r="2" fill="white" />
        </svg>
      </div>
      <div class="mt-[8px]">{$t("wechat_tip_2")}</div>
    </div>
  </div>
{/if}
